export default "__VITE_ASSET__BPDpnBbM__"